import { Component, OnInit } from "@angular/core";
import { DataService } from "src/app/data.service";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { GUID } from "./../../guid";
import { ToastService } from "ng-uikit-pro-standard";
import { Location } from "@angular/common";
import { AppConfig } from "src/app/config";
import { eventId } from "src/app/eventid";
import { getRequestID } from "src/app/requestid";

@Component({
  selector: "app-processfield",
  templateUrl: "./processfield.component.html",
  styleUrls: ["./processfield.component.scss"]
})
export class ProcessfieldComponent implements OnInit {
  isLoading = false;
  isError = false;
  errorMessage = "";
  fields = [];
  mode = "new";
  processId = "";
  metaobjectId = "";
  description = "";
  active: boolean;
  metaobjectName = "";
  fieldName = "";
  Name = "";
  fieldsToDo: any[] = [];
  fieldsDone: any[] = [];
  index: any;
  guid: GUID;
  process: any;

  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private toastrService: ToastService
  ) {
    if (!this.fieldsDone) {
      this.fieldsDone = [];
    }
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.metaobjectId = this.route.snapshot.params.metaobjectid;
      this.metaobjectName = this.route.snapshot.params.metaobjectname;
      this.description = this.route.snapshot.params.description;
      this.active = this.route.snapshot.params.active;
      this.Name = this.route.snapshot.params.name;
      this.processId = this.route.snapshot.params.id;
      this.mode = this.route.snapshot.params.mode;
      console.log(this.mode);
      console.log(this.Name);

      this.guid = new GUID();
    });
    console.log(this.metaobjectName);

    if (this.mode === "new") {
      this.getProcessFields();
    }

    if (this.mode === "edit") {
      this.getProcessFields().then((res) => {
        this.getProcessById();
      });
    }

    // const formData = this.route.snapshot.state.formData.metaobjectname;
    // console.log(formData)
  }

  FieldSelection(field: any) {
    field.selected = !field.selected;
  }
  FieldDeSelection(field: any) {
    field.selected = !field.selected;
  }
  moveSelectedFieldsToDone() {
    // const selectedFields = this.fieldsToDo.filter((field) => field.selected);
    const selectedFields = this.fieldsToDo.filter((field) => field.selected);

    console.log(selectedFields);
    this.fieldsDone.push(...selectedFields);
    this.fieldsToDo = this.fieldsToDo.filter((field) => !field.selected);
    selectedFields.forEach((field) => (field.selected = false));
  }

  moveSelectedFieldsToDo() {
    const selectedFields = this.fieldsDone.filter((field) => field.selected);
    console.log(selectedFields);

    this.fieldsToDo.push(...selectedFields);
    this.fieldsDone = this.fieldsDone.filter((field) => !field.selected);
    selectedFields.forEach((field) => (field.selected = false));
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark"
    };
    this.toastrService.warning(data, "", options);
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  getProcessFields() {
    return new Promise((resolve, reject) => {
      console.log("ProcessFields");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          process: {
            metaobjectid: this.metaobjectId,
            metaobjectname: this.metaobjectName
          }
        }
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getProcessFields(postOption).subscribe(
        (res) => {
          console.log("res", res);

          if (res !== null && res.success == 1) {
            // const fields = res.data.processfield.map((field:any)=>{
            //   console.log(field);
            //   return field.label
            // });
            // this.fields = fields
            // console.log(this.fields);

            this.fieldName = res.data.processfield[0].fieldname;
            console.log(this.fieldName);

            const fields = JSON.parse(res.data.processfield[0].processfield);
            this.fields = fields;

            console.log(this.fields);

            this.fieldsToDo = this.fields;

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No data!");
            this.errorMessage = res != null ? res.message : "No data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getProcessById() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        process: {
          id: this.processId,
          name: this.Name
        }
      }
    };
    console.log(this.processId);
    console.log(postOption);
    this.isLoading = true;
    this.dataService.getProcessById(postOption).subscribe(
      (res) => {
        // alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.process = res.data.process[0];
          console.log("Doneeee****", this.process);
          if (this.process != null) {
            // this.fieldsDone = this.process.fields;

            // this.id = this.process.id;
            // this.name = this.process.name;

            const values = this.process.values.split(",");

            console.log(values);

            this.fieldsDone = values.map((value) => ({
              label: value,
              value: value,
              selected: false
            }));
            this.processFieldsToDo();
            console.log(this.fieldsDone);
          }

          this.isLoading = false;
        } else {
          console.log("no data");
          this.isLoading = false;
          //this.resetDetailFormControls();
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        //this.resetDetailFormControls();
      }
    );
  }

  processFieldsToDo() {
    const doneLabels = this.fieldsDone.map((field) => field.label);
    this.fieldsToDo = this.fieldsToDo.filter(
      (field) => !doneLabels.includes(field.label)
    );
  }

  save() {
    console.log("actionForm", this.mode);

    if (this.mode == "new") {
      this.processId = this.guid.getGUID("process");
    }

    const fieldValue = this.fieldsDone.map((field) => field.label);

    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      data: {
        process: {
          // id: this.guid.getGUID("metaglobalaction"),
          id: this.processId,
          mode: this.mode,
          name: this.Name,
          metaobjectid: this.metaobjectId,
          metaobjectname: this.metaobjectName,
          fieldname: this.fieldName,
          description: this.description,
          values: fieldValue,
          active: this.active,
          fields: this.fieldsDone
        }
      }
    };
    console.log("postOption", postOption);

    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    // let publish = {
    //   // topic: "scherp.admin.basicaccesspermission.created",
    //   topic: `${domain}.admin.basicaccesspermission.created`, // ✅ dynamic

    //   group_id: "create_basicaccesspermission",
    //   message: [
    //     {
    //       context: {
    //         organizationid: localStorage.getItem("crm_orgid")
    //       },
    //       user: {
    //         org_code: localStorage.getItem(
    //           `${localStorage.getItem("crm_orgid")}.subdomain`
    //         )
    //       },
    //       domain: domain,
    //       // domain: localStorage.getItem(
    //       //   `${localStorage.getItem("crm_orgid")}.domain`
    //       // ),
    //       subdomain: localStorage.getItem(
    //         `${localStorage.getItem("crm_orgid")}.subdomain`
    //       )

    //       // action: {
    //       //   modulename: metaobjectName,
    //       // },
    //     }
    //   ]
    // };
    const orgId = localStorage.getItem("crm_orgid");

    const event_id = eventId("Metadata", this.metaobjectName, "create");
    const requestid = getRequestID();
    const subdomain = localStorage.getItem(`${orgId}.subdomain`);
    let topic =
      this.mode.toLowerCase() === "new"
        ? `${domain}.metadata.process.created`
        : `${domain}.metadata.process.updated`;
    let publish = {
      topic: topic,
      group_id: "metadata",
      message: [
        {
          current_context: {},

          context: {
            organizationid: orgId
          },

          user: {
            user_name: localStorage.getItem("crm_loginid"),

            _id: localStorage.getItem("crm_userid"),

            name: localStorage.getItem("crm_username"),

            app_name: domain
          },

          domain: domain,

          subdomain: subdomain,

          action: {
            modulename: this.metaobjectName,
            event_id: event_id
          },

          // relative_url: "api/v1/turbo/c/metaobject",

          query: {}
        }
      ],
      relative_url: "api/v1/turbo/c/metaobject",

      request_id: requestid
    };

    console.log("publish", publish);

    // alert(formData)
    this.dataService.upsertProcess(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl("/home/processes");
          this.dataService.outboxeventPublish(publish).subscribe();
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }

  // cancel() {
  //   this.router.navigateByUrl('home/process/new')
  // }

  cancel() {
    this.location.back();
  }
}
